import { coreService } from "../../../../services/core/core-service";
import { CommentOnClipResponse } from "../../../../services/types";
import { Clip, Utterance } from "./types";
import { createUtterances } from "./utils";

export const fetchClip = async (clipId: string, secret: string): Promise<Clip> => {
  const clip = await coreService.getClipById(clipId, secret);
  const transcript: Utterance[] = createUtterances(clip);
  return {
    ...clip,
    transcript,
  };
};

export const commentOnClip = async (clipId: string, content: string): Promise<CommentOnClipResponse> => {
  return await coreService.commentOnClip(clipId, content);
};

export const deleteClip = async (clipId: string): Promise<void> => {
  await coreService.deleteClip(clipId);
};

export const deleteComment = async (clipId: string, commentId: string): Promise<void> => {
  await coreService.deleteComment(clipId, commentId);
};

export const incrementViews = async (clipId: string): Promise<number> => {
  return await coreService.incrementViews(clipId);
};

export const addReaction = async (clipId: string, reaction: string, timestamp: number): Promise<void> => {
  await coreService.addClipReaction(clipId, reaction, timestamp);
};